<section class="text-center contracts-list-table-container">

  <div class="w-100 text-center mt-5"
    *ngIf="contracts.length === 0 && !loaderService?.isLoading">
    <h4>{{'CONTRACTS.EMPTY_LIST_CONTRACTS' | translate}}</h4>
  </div>

  <table mat-table
    [dataSource]="contracts"
    matSort
    class="mt-2"
    *ngIf="contracts && contracts.length >0">

    <ng-container matColumnDef="{{column}}"
      *ngFor="let column of displayedColumns"
      [ngSwitch]="column">

      <ng-container *ngSwitchCase="'contractId'">
        <th mat-header-cell
          *matHeaderCellDef>
          <ng-container [ngTemplateOutlet]="sortColumnComponent"
            [ngTemplateOutletContext]="{column}">
          </ng-container>
        </th>
        <td mat-cell
          *matCellDef="let element"> {{element.contractId}} </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'contractName'">
        <th mat-header-cell
          *matHeaderCellDef>
          <ng-container [ngTemplateOutlet]="sortColumnComponent"
            [ngTemplateOutletContext]="{column}">
          </ng-container>
        </th>
        <td mat-cell
          *matCellDef="let element"> {{element.contractName}} </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'businessName'">
        <th mat-header-cell
          *matHeaderCellDef>
          <ng-container [ngTemplateOutlet]="sortColumnComponent"
            [ngTemplateOutletContext]="{column}">
          </ng-container>
        </th>
        <td mat-cell
          *matCellDef="let element"> {{element.businessName}} </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'seller'">
        <th mat-header-cell
          *matHeaderCellDef>
          <ng-container [ngTemplateOutlet]="sortColumnComponent"
            [ngTemplateOutletContext]="{column}">
          </ng-container>
        </th>
        <td mat-cell
          *matCellDef="let element"> {{element.seller}} </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'entryDate'">
        <th mat-header-cell
          *matHeaderCellDef
          class="date-column">
          <ng-container [ngTemplateOutlet]="sortColumnComponent"
            [ngTemplateOutletContext]="{column}">
          </ng-container>
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="date-column">
          {{element.entryDate | bitfDate:'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container *ngSwitchCase="'expirationWarning'">
        <th mat-header-cell
          *matHeaderCellDef
          class="boolean-column">
          {{'CONTRACTS.EXPIRATION_WARNING' | translate}}
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="boolean-column">
          <div *ngIf="element.showExpirationWarning || element.showExpirationEndWarning"
            class="expiration-warning-indicator"
            [class.expiration-warning-indicator-end]="element.showExpirationEndWarning"
            [matTooltip]="getExpirationTooltip(element)"
            matTooltipPosition="above">
            <mat-icon>warning</mat-icon>
          </div>
        </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'isInvoiced'">
        <th mat-header-cell
          *matHeaderCellDef
          class="boolean-column">
          {{'CONTRACTS.IS_INVOICED' | translate}}
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="boolean-column">
          <div class="boolean-indicator"
            [class.success]="element.isInvoiced"
            [class.error]="!element.isInvoiced">
            <mat-icon>{{element.isInvoiced ? 'check' : 'close'}}</mat-icon>
          </div>
        </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'isContracted'">
        <th mat-header-cell
          *matHeaderCellDef
          class="boolean-column">
          {{'CONTRACTS.IS_CONTRACTED' | translate}}
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="boolean-column">
          <div class="boolean-indicator"
            [class.success]="element.isContracted"
            [class.error]="!element.isContracted">
            <mat-icon>{{element.isContracted ? 'check' : 'close'}}</mat-icon>
          </div>
        </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'isAllAttachmentSigned'">
        <th mat-header-cell
          *matHeaderCellDef
          class="boolean-column">
          {{'CONTRACTS.ALL_ATTACHMENTS_SIGNED_TABLE_HEADER' | translate}}
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="boolean-column">
          <div class="boolean-indicator"
            [class.success]="element.isAllAttachmentSigned"
            [class.error]="!element.isAllAttachmentSigned">
            <mat-icon>{{element.isAllAttachmentSigned ? 'check' : 'close'}}</mat-icon>
          </div>
        </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'isPsAssigned'">
        <th mat-header-cell
          *matHeaderCellDef
          class="boolean-column">
          {{'CONTRACTS.IS_PS_ASSIGNED' | translate}}
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="boolean-column">
          <div class="boolean-indicator"
            [class.success]="element.isPsAssigned"
            [class.error]="!element.isPsAssigned">
            <mat-icon>{{element.isPsAssigned ? 'check' : 'close'}}</mat-icon>
          </div>
        </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'isInvoiced'">
        <th mat-header-cell
          *matHeaderCellDef
          class="boolean-column">
          {{'CONTRACTS.IS_INVOICED' | translate}}
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="boolean-column">
          <div class="boolean-indicator"
            [class.success]="element.isInvoiced"
            [class.error]="!element.isInvoiced">
            <mat-icon>{{element.isInvoiced ? 'check' : 'close'}}</mat-icon>
          </div>
        </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'state'">
        <th mat-header-cell
          *matHeaderCellDef
          class="state-column">

          <ng-container [ngTemplateOutlet]="sortColumnComponent"
            [ngTemplateOutletContext]="{column}">
          </ng-container>
        </th>
        <td mat-cell
          *matCellDef="let element"
          class="state-column">

          <tim-status-chip [status]="element.state"
            [type]="eStatusType.CONTRACT"
            [contract]="element"
            [isEditable]="false"></tim-status-chip>
        </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

      <ng-container *ngSwitchCase="'action'">
        <th mat-header-cell
          *matHeaderCellDef>
        </th>
        <td mat-cell
          [routerLink]="'/contracts/'+[element.documentId]"
          class="cursor-pointer"
          *matCellDef="let element"> <mat-icon>visibility</mat-icon> </td>
        <td mat-footer-cell
          *matFooterCellDef></td>
      </ng-container>

    </ng-container>

    <tr mat-header-row
      *matHeaderRowDef="displayedColumns;sticky:true"></tr>
    <tr mat-row
      *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</section>
<bitf-mat-paginator *ngIf="contracts && contracts.length >0"
  [pagination]="pagination"
  [apiCallStateName]="apiCallStateName"
  [showFirstLastButtons]="true"></bitf-mat-paginator>


<ng-template #sortColumnComponent
  let-column="column">
  <bitf-mat-sort *ngIf="orderSortings[column]"
    [apiCallStateName]="apiCallStateName"
    [apiRequestPartKey]="orderSortings[column].key"
    [option]="orderSortings[column]"
    [class]="'btn-neutral'"></bitf-mat-sort>
</ng-template>